/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import MasterUsersLists from "./MasterUsersLists";
import MasterCustomerList from "./MasterCustomerList";
import { useLocation } from "react-router-dom";
import urls from "../../../api/urls";
const {
  GET_CP_MASTER_LIST_V1,
  GET_CLIENT_MASTER_LIST_V1,
  GET_COMPANY_MASTER_LIST_V1,
} = urls;
const AllMasterLists = () => {
  const [activeKey, setActiveKey] = useState("1");
  const [destroy, setDestroy] = useState(false);
  const [updateStaff, setUpdateStaff] = useState();

  const { state } = useLocation();
  useEffect(() => {
    if (state) {
      setActiveKey(state.toString());
    }
  }, [state]);

  const changeTab = (key) => {
    setActiveKey(key);
    setDestroy(false);
  };

  return (
    <div className="p-2">
      <div className="global-card-tab-container">
        <Tabs
          activeKey={activeKey}
          destroyInactiveTabPane={destroy}
          onChange={changeTab}
          items={[
            {
              label: "CP Master",
              key: "1",
              children: (
                <MasterCustomerList
                  userType={"CP"}
                  tabKey={"1"}
                  url={"/master-list"}
                  apiUrl={GET_CP_MASTER_LIST_V1}
                  showWallet={false}
                  //actionEdit={true}
                />
              ),
            },
            {
              label: "Company Master",
              key: "2",
              children: (
                <MasterCustomerList
                  userType={"COMPANY"}
                  tabKey={"2"}
                  url={"/master-list"}
                  apiUrl={GET_COMPANY_MASTER_LIST_V1}
                  actionEdit={true}
                  showWallet={true}
                />
              ),
            },

            {
              label: "Client Master",
              key: "3",
              children: (
                <MasterCustomerList
                  userType={"CLIENT"}
                  tabKey={"3"}
                  url={"/master-list"}
                  apiUrl={GET_CLIENT_MASTER_LIST_V1}
                  actionEdit={true}
                  basicEdit={true}
                />
              ),
            },
            {
              label: "User Master",
              key: "4",
              children: <MasterUsersLists />,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default AllMasterLists;
